import { newThemeOptions } from 'src/theme/theme';

const initialColours = Object.values(newThemeOptions.newPalette.chart);

export const getOrderedColor = (index: number) => {
  if (index < initialColours.length) {
    return initialColours[index];
  } else {
    return initialColours[index % initialColours.length];
  }
};
